import cn from 'classnames';
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useTranslation } from 'next-i18next';
import { useCallback, useRef } from 'react';
import { UseRefinementListProps, useRefinementList } from 'react-instantsearch';

import RatingStars from '@components/product/ProductRatingStars';

import useTabVisibility from '@hooks/useTabVisibility';

import styles from './RatingRefinement.module.scss';

const refinementListClassNames = {
  root: styles.refinementListRoot,
  searchBox: styles.refinementListSearchBox,
  noRefinementRoot: styles.noRefinementRoot,
  list: styles.refinementListList,
  item: styles.refinementListItem,
  label: styles.refinementListLabel,
  count: styles.refinementListCount,
  checkbox: styles.refinementListCheckbox,
  showMore: styles.refinementListshowMore,
};

const ListRatingRefinement = (
  props: UseRefinementListProps & { locale?: string }
) => {
  const sortDescending = useCallback(
    (arr: RefinementListItem[]) =>
      arr.sort((a, b) => {
        return parseInt(b.value) - parseInt(a.value);
      }),
    []
  );
  const { items, refine } = useRefinementList({
    ...props,
    transformItems: sortDescending,
    limit: 100,
    operator: 'or',
  });

  const { t } = useTranslation('searchResults');
  const clearButtonRef = useRef<HTMLButtonElement>(null);

  const refinedItems = items.filter((item) => item.isRefined);
  const isClearButtonDisplayed = refinedItems.length > 1;

  const formatNumber = (count: number) =>
    new Intl.NumberFormat(props.locale ?? 'en').format(count);

  useTabVisibility(clearButtonRef);

  return (
    <div className={refinementListClassNames.root}>
      <ul className={refinementListClassNames.list}>
        {items
          .filter((item) => item.value !== '0')
          .map((item) => (
            <li key={item.label} className={refinementListClassNames.item}>
              <label
                className={refinementListClassNames.label}
                aria-label={item.label}
              >
                <input
                  type="checkbox"
                  checked={item.isRefined}
                  onChange={(e) => {
                    e.preventDefault();
                    refine(item.value);
                  }}
                  className={refinementListClassNames.checkbox}
                />

                <RatingStars rating={parseFloat(item.value)} />
                <span className={refinementListClassNames.count}>
                  {' '}
                  ({formatNumber(item.count)})
                </span>
              </label>
            </li>
          ))}
        <li
          className={cn(refinementListClassNames.item, styles.clearFilterItem, {
            [styles.clearFilterDisplayed]: isClearButtonDisplayed,
          })}
        >
          <button
            onClick={() => refinedItems.forEach((item) => refine(item.value))}
            className={cn(
              refinementListClassNames.label,
              styles.clearFilterButton
            )}
            ref={clearButtonRef}
          >
            {t('search.facets.productRating.clear')}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ListRatingRefinement;
